export default __webpack_public_path__ + "static/media/bears-getting-rekt.c9f0f687.jpeg";